import { render, staticRenderFns } from "./SendFromDataPopup.vue?vue&type=template&id=2eca17f0&scoped=true"
import script from "./SendFromDataPopup.vue?vue&type=script&lang=js"
export * from "./SendFromDataPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca17f0",
  null
  
)

export default component.exports